import { render } from "./Default_Settings.vue?vue&type=template&id=cc43fa52&scoped=true"
import script from "./Default_Settings.vue?vue&type=script&lang=js"
export * from "./Default_Settings.vue?vue&type=script&lang=js"

import "./Default_Settings.vue?vue&type=style&index=0&id=cc43fa52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc43fa52"]])

export default __exports__